var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTataLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 18,
    viewBox: "0 0 81 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.016 6.04191C25.6952 5.40635 25.2728 4.79721 24.7472 4.22596C23.5662 2.94165 21.8998 1.87293 19.9278 1.13584C17.9396 0.393038 15.6719 0 13.3674 0C11.0629 0 8.79517 0.393038 6.80797 1.13584C4.83497 1.87302 3.16855 2.94173 1.9875 4.22596C1.4623 4.79712 1.03846 5.40712 0.717773 6.04302C3.28505 5.41751 7.67652 4.59166 11.7541 4.50434C12.1474 4.49583 12.4182 4.62275 12.5965 4.85045C12.8137 5.12772 12.7974 6.11611 12.7921 6.55829L12.6761 17.9874C12.9058 17.9951 13.1365 18 13.3674 18C13.6002 18 13.8322 17.9962 14.0619 17.9885L13.946 6.55821C13.94 6.11611 13.9231 5.12763 14.1411 4.85036C14.3198 4.62275 14.5897 4.49583 14.9829 4.50426C19.0588 4.59089 23.4492 5.41692 26.016 6.04191Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5681 7.52809C22.8107 6.67225 20.3014 6.51398 17.8255 6.37555C15.6674 6.25468 15.6392 7.03113 15.8546 8.51494C15.8687 8.60549 15.8861 8.71964 15.9066 8.8498C16.6305 13.1696 17.532 16.8871 17.6869 17.518C22.9482 16.3063 26.7426 12.9467 26.7426 9.00015C26.7426 8.50319 26.683 8.01082 26.5681 7.52809Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8905 8.51503C11.1062 7.0313 11.0786 6.25476 8.92066 6.37564C6.44394 6.51406 3.93407 6.67225 0.175182 7.52868C0.0603666 8.01142 0 8.50319 0 9.00015C0 10.7059 0.688722 12.3564 1.99193 13.7744C3.17297 15.0588 4.8394 16.1275 6.81239 16.8651C7.52648 17.1314 8.28005 17.3498 9.05628 17.5244C9.20195 16.9333 10.1241 13.1385 10.8559 8.74145C10.8694 8.6572 10.8819 8.57943 10.8905 8.51503Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7568 2.56348H42.0937V6.34594H38.5545V15.4364H33.4138V6.34594H29.7568V2.56348Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3419 7.76465L45.7445 15.4364H40.8076L45.6495 2.56348H51.0111L55.9696 15.4364H50.9721L48.3419 7.76465Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.791 2.56348H67.1274V6.34594H63.5893V15.4364H58.4488V6.34594H54.791V2.56348Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.377 7.76465L70.7786 15.4364H65.8418L70.6853 2.56348H76.0452L81.0021 15.4364H76.0064L73.377 7.76465Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTataLogo);
export default __webpack_public_path__ + "static/media/TataLogo.1d6d37a20ef38f18e9b0219e7c90689d.svg";
export { ForwardRef as ReactComponent };